import type { TabId } from "./types";

export const EMOJI_PICKER_SUGGESTED_STORAGE_KEY = "epr_suggested";

export interface TabItem {
  id: TabId;
  labelKey: string;
}

export const TAB_ITEMS: TabItem[] = [
  { id: "emoji", labelKey: "emoji_picker_v4.tabs.emoji" },
  { id: "shapes", labelKey: "emoji_picker_v4.tabs.shapes" },
  { id: "icons", labelKey: "emoji_picker_v4.tabs.icons" },
  { id: "custom", labelKey: "emoji_picker_v4.tabs.custom" },
];
